import { signOut } from 'aws-amplify/auth';
import { getCookiesAsObject } from '@whitelabel/helpers/utils';
import { AUTH_TOKEN_STORAGE_NAME } from '@whitelabel/rentalcover-shared/helpers/constants';
import { clearAuthTokens } from '@whitelabel/xcover-shared/helpers/api';
import { LWA_LOCALE } from '@whitelabel/xcover-shared/helpers/constants';

export const getRCAuthToken = (): string | undefined => getCookiesAsObject()?.[AUTH_TOKEN_STORAGE_NAME];

const REFRESH_TOKEN_KEY = 'RC_REFRESH_TOKEN';

export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setRefreshToken = (token: string): void => localStorage.setItem(REFRESH_TOKEN_KEY, token);
export const clearRefreshToken = (): void => localStorage.removeItem(REFRESH_TOKEN_KEY);

export const handleUnlinkedLWAUser = async () => {
  const lwaLocale = sessionStorage.getItem(LWA_LOCALE) || 'en';
  clearAuthTokens();
  await signOut();
  window.location.href = `/${lwaLocale}/session-expired`;
};
